


















































import { SXQuestion } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Watch, Prop, Emit } from "vue-property-decorator";

@Component
export default class WQuestionEditor extends BaseComponent {
	@Prop({ type: SXQuestion, required: true })
	question!: SXQuestion;

	state = {
		type: "",
		question: ""
	};
	qData = this.ux_question_data(this.question);

	@Watch("qData", { deep: true })
	watchQData(val: any) {
		this.question.data = JSON.stringify(val);
	}

	@Watch("isDirty")
	watchIsDirty(dirty: boolean) {
		this.onQuestionStateChange();
	}

	@Emit("question-state-change")
	onQuestionStateChange() {
		return this.isDirty;
	}

	get label() {
		return this.question.label;
	}
	set label(val: string) {
		this.question.label = val;
	}

	get type() {
		return this.question.type;
	}
	set type(val: string) {
		this.question.type = val;
	}

	get subLabel(): string {
		return this.qData.subLabel;
	}
	set subLabel(val: string) {
		this.qData.subLabel = val;
	}

	get required(): boolean {
		return this.qData.required;
	}
	set required(val: boolean) {
		this.qData.required = val;
	}

	get form() {
		return getForm();
	}

	get isDirty() {
		return this.state.question === "dirty" || this.state.type === "dirty";
	}

	toggleRequired($e: any) {
		this.qData.required = !!$e.target.checked;
	}
	onTypeStateChange(state: boolean) {
		this.state.type = state ? "clean" : "dirty";
	}
	onQuestionFormChange() {
		this.state.question = this.checkForm() ? "clean" : "dirty";
	}
	checkForm() {
		return this.question.label.length && this.question.type;
	}

	mounted() {
		this.onQuestionFormChange();
	}
}

const getForm = function() {
	return {
		fields: {
			label: {
				field: "input",
				label: { i18n: "SX_LANG_QUESTION_LABEL" },
				attrs: {
					name: SXQuestion.COL_LABEL,
					autocomplete: "off",
					autofocus: "autofocus"
				},
				i18n: { placeholder: "SX_LANG_QUESTION_LABEL" }
			},
			subLabel: {
				field: "textarea",
				label: { i18n: "SX_LANG_QUESTION_SUB_LABEL" },
				attrs: {
					name: "sub_label"
				},
				i18n: { placeholder: "SX_LANG_QUESTION_SUB_LABEL" }
			},
			type: {
				field: "select",
				label: { i18n: "SX_LANG_QUESTION_TYPE" },
				attrs: {
					name: "type"
				},
				i18n: { placeholder: "SX_LANG_QUESTION_TYPE" },
				options: [
					{
						attrs: { value: "" }
					},
					{
						attrs: { value: "text" },
						i18n: "SX_LANG_QUESTION_TYPE_TEXT"
					},
					{
						attrs: { value: "radio" },
						i18n: "SX_LANG_QUESTION_TYPE_RADIO"
					},
					{
						attrs: { value: "checkbox" },
						i18n: "SX_LANG_QUESTION_TYPE_CHECKBOX"
					},
					{
						attrs: { value: "bigtext" },
						i18n: "SX_LANG_QUESTION_TYPE_BIGTEXT"
					}
				]
			},
			required: {
				field: "checkbox",
				label: { i18n: "SX_LANG_REQUIRED" },
				attrs: {
					name: "required"
				}
			}
		}
	};
};
